import { api } from "./api";

export const inventoryReportApi = (params) => {
    return api.get(`/reports/inventory`, { params });
};

export const stockInReportApi = (params) => {
    return api.get(`/reports/stock-in`, { params });
};

export const productSalesReportApi = (params) => {
    return api.get(`/reports/product-sales`, { params });
};